module.exports = __webpack_public_path__ + "images/emoji/saxophone.e9022a0758b4dffab348.png";